// removes queryparams and hashes from a full url or pathname
export var stripQueryParams = function stripQueryParams(url) {
  var _url$split$;

  return (_url$split$ = url.split('?')[0]) === null || _url$split$ === void 0 ? void 0 : _url$split$.split('#')[0];
};
export var isNonNullObject = function isNonNullObject(obj) {
  return typeof obj === 'object' && obj !== null;
};